package com.narbase.letsgo.web.views.user.profile

import com.narbase.kunafa.core.components.*
import com.narbase.kunafa.core.css.*
import com.narbase.kunafa.core.dimensions.dependent.wrapContent
import com.narbase.kunafa.core.dimensions.em
import com.narbase.kunafa.core.dimensions.px
import com.narbase.kunafa.core.drawable.Color
import com.narbase.kunafa.core.lifecycle.LifecycleOwner
import com.narbase.letsgo.web.common.AppColors
import com.narbase.letsgo.web.common.AppFontSizes
import com.narbase.letsgo.web.storage.StorageManager
import com.narbase.letsgo.web.storage.StoredStringValue

import com.narbase.letsgo.web.utils.views.asDimension

/**
 * NARBASE TECHNOLOGIES CONFIDENTIAL
 * ______________________________
 * [2017] -[2019] Narbase Technologies
 * All Rights Reserved.
 * Created by islam
 * On: 2020/01/29.
 */

class EditablePhoneNumberView : Component() {
    private var callingCode: TextInput? = null
    private var phoneNumberInput: TextInput? = null
    private var savedCallingCode by StoredStringValue("SAVED_CALLING_CODE")
    override fun onViewCreated(lifecycleOwner: LifecycleOwner) {
        super.onViewCreated(lifecycleOwner)
        disableEdit()
    }

    override fun View?.getView() = horizontalLayout {
        style {
            alignItems = Alignment.Center
        }
        textView {
            text = "+"
            addRuleSet(readOnlyRuleSet)
        }
        callingCode = textInput {
            text = savedCallingCode ?: ""
            element.disabled = true
            element.size = 4
            element.type = "number"
            style {
                borderRadius = 4.px
                width = 4.em
            }
            onChange = {
                savedCallingCode = text
            }
        }
        phoneNumberInput = textInput {
            element.disabled = true
            element.type = "number"
            style {
                width = wrapContent
                borderRadius = 4.px
            }
        }
    }

    fun focusOnPhoneNumberInput() {
        phoneNumberInput?.element?.focus()
    }

    var code: String
        get() = callingCode?.text ?: ""
        set(value) {
            callingCode?.text = value.trim().trim('+')
        }

    var phoneNumber: String
        get() = phoneNumberInput?.text ?: ""
        set(value) {
            phoneNumberInput?.text = value
        }

    fun enableEdit() {
        callingCode?.removeRuleSet(readOnlyRuleSet)
        callingCode?.addRuleSet(editableRueSet)
        callingCode?.element?.disabled = false

        phoneNumberInput?.removeRuleSet(readOnlyRuleSet)
        phoneNumberInput?.addRuleSet(editableRueSet)
        phoneNumberInput?.element?.disabled = false
    }

    fun disableEdit() {
        callingCode?.addRuleSet(readOnlyRuleSet)
        callingCode?.removeRuleSet(editableRueSet)
        callingCode?.element?.disabled = true

        phoneNumberInput?.addRuleSet(readOnlyRuleSet)
        phoneNumberInput?.removeRuleSet(editableRueSet)
        phoneNumberInput?.element?.disabled = true
    }

    fun disableCodeEdit() {
        callingCode?.addRuleSet(readOnlyRuleSet)
        callingCode?.removeRuleSet(editableRueSet)
        callingCode?.element?.disabled = true
    }

    companion object {
        private val readOnlyRuleSet by lazy {
            classRuleSet {
                cursor = "default"
                border = "none"
                padding = "0px 0px".asDimension()
//                padding = "4px 0px".asDimension()
                backgroundColor = Color.transparent
                color = Color.black
                fontSize = AppFontSizes.normalText
            }
        }

        private val editableRueSet by lazy {
            classRuleSet {
                cursor = "text"
                padding = 6.px
                marginStart = 4.px
                border = "1px solid ${AppColors.textInputBorderColor}"
                backgroundColor = Color.transparent
                color = Color.black
                fontSize = AppFontSizes.normalText
            }
        }
    }
}

